// filepath: /home/codecz/Dokumen/GITHUB/new-ketaqwaan-website/client-frontend/src/App.jsx
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Pengumuman from './pages/Pengumuman'
import Pendaftaran from './pages/Pendaftaran'
import Mading from './pages/Mading'
import LoadingSpinner from './components/LoadingSpinner'
import ErrorBoundary from './components/ErrorBoundary'
import NotFound from './components/NotFound'
import MadingDetail from './pages/MadingDetail'

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pengumuman" element={<Pengumuman />} />
            <Route path="/pendaftaran" element={<Pendaftaran />} />
            <Route path="/mading" element={<Mading />} />
            <Route path="/mading/:slug" element={<MadingDetail />} />
            <Route path="*" element={<NotFound/>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  )
}

export default App